import styled from 'styled-components';

export const Wrapper = styled.div`
  
`;

export const Text = styled.span`
  ${(props) => props.theme.fonts.interSemibold24};
  color: ${(props) => props.theme.colors.white100};
`;

export const Counter = styled.span`
  ${(props) => props.theme.fonts.interSemibold13};
  color: ${(props) => props.theme.colors.secondary};
  margin-left: .8rem;
`;